export const hydratePlaceTreeTemplates = job => {
  if (!job) return job;
  const templates = new Map((job.plan?.equipment?.templates || []).map(template => [template.templateRef, template]));
  return {
    ...job,
    ...(job.plan?.equipment ? { plan: { ...job.plan, equipment: { ...job.plan.equipment,
      items: job.plan.equipment.items.map(item => item.templateRef && !item.name ? {
        ...templates.get(item.templateRef), ...item,
        recordConstraints: { ...templates.get(item.templateRef)?.recordConstraints, ...item.recordConstraints },
      } : item),
    } } } : {}),
    records: Object.fromEntries(Object.entries(job.records || {}).map(([ref, record]) => {
      if (!record.templateInstance) return [ref, record];
      const { templateInstance, ...instance } = record;
      return [ref, { ...job.itemTemplateRecords?.[record.templateGenerationKey], ...instance }];
    })),
  };
};
